module.exports = __webpack_public_path__ + "img/15-SANGDRAGON_2-min.56666d5a.jpg";